import { render, staticRenderFns } from "./ModalStudentStatus.vue?vue&type=template&id=6e2a8899&scoped=true&lang=pug&"
import script from "./ModalStudentStatus.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentStatus.vue?vue&type=style&index=0&id=6e2a8899&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a8899",
  null
  
)

export default component.exports